import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import type { Briefing } from "@/lib/types";

export const useBriefing = () => useQuery({ queryKey: ["briefing"], queryFn: async () => (await api<{ data: Briefing }>("/api/briefing")).data });

export function useBriefingNarrative() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (force: boolean) => api<{ data: Briefing["narrative"] }>("/api/briefing/narrative", { method: "POST", json: { force } }),
    onSuccess: () => Promise.all([qc.invalidateQueries({ queryKey: ["briefing"] }), qc.invalidateQueries({ queryKey: ["me"] })]),
    onError: (e) => toast.error(e.message),
  });
}
